import React from 'react';

/** Red asterisk shown next to the label of every mandatory field. */
export function RequiredMark() {
  return <span className="text-red-500 ml-0.5" aria-hidden="true">*</span>;
}

/** Inline validation message shown directly under the offending field. */
export function FieldError({ error }) {
  if (!error) return null;
  return (
    <p data-field-error className="mt-1 text-xs text-red-500" role="alert">{error}</p>
  );
}

/** Extra classes that turn an input/select/textarea border red when it has an error. */
export function errBorder(error) {
  return error ? '!border-red-500 focus:!ring-red-500' : '';
}
